import { Box, ThemeProvider } from '@mui/material'
import Header from './Layout/Header'
import theme from '../styles/theme'
import { useContext } from 'react'
import { AbilityContext, Can } from '../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../models/AccessControl'
import SubscriptionModal from '../components/Payment/SubscriptionModal'

function Subscription() {
  const ability = useContext(AbilityContext)

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          minWidth: '800px',
        }}
      >
        <Can I={AttributeActionNames.Read} a={AttributeResourceNames.MainPage}>
          <Header />
        </Can>
      </Box>
    </ThemeProvider>
  )
}

export default Subscription
